import axios from 'axios';
import {
  API_MAX_RETRY_COUNT,
  ENABLE_API_ERROR_CONSOLE_LOGS,
} from '../constants/config';
import { getApiHeaders } from '../utils';
import { USER_TYPE } from '../constants';
const apiClient = (
  url,
  optArgs = {
    retryEnabled: true,
    extraHeaders: {},
    isBypass: false,
  }
) => {
  let headers = getApiHeaders();
  if (optArgs?.extraHeaders) {
    headers = {
      ...headers,
      ...optArgs.extraHeaders,
    };
  }

  let retryCounter = 0;
  const axiosInstance = axios.create({
    baseURL: url,
    headers: headers,
  });

  axiosInstance.interceptors.request.use(
    (config) => {
      const token = sessionStorage.getItem('token');
      const userType = sessionStorage.getItem('userType');
      if (token) {
        config.headers['Authorization'] = `${userType === USER_TYPE.internalUser ? 'Bearer' : ''} ${token}`;
        config.headers['User-Type'] = `${userType}`;
      }
      return config;
    },
    (error) => {
      console.error(
        `Intercepted request error for ${error.config.baseURL}${error.config.url}:\n${error.stack}`
      );
      return Promise.reject(error);
    }
  );

  axiosInstance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      const fullUrl = error.config.baseURL.concat(error.config.url);
      let retryEnabled = true;
      // override if retryEnabled flag is set
      if (optArgs?.retryEnabled !== undefined) {
        retryEnabled = optArgs.retryEnabled;
        console.warn(
          `retryEnabled is overriden to ${retryEnabled} for ${fullUrl}`
        );
      }

      if (ENABLE_API_ERROR_CONSOLE_LOGS) {
        console.error(
          `Intercepted response error for ${fullUrl}:\n${error.stack}\n`,
          {
            status: error.response?.status || null,
            response: error.response?.data || null,
          }
        );
      }
      if (retryEnabled && retryCounter++ < API_MAX_RETRY_COUNT) {
        if (ENABLE_API_ERROR_CONSOLE_LOGS) {
          console.info(`Retrying ${fullUrl} with retry count ${retryCounter}`);
          return new Promise((resolve) => {
            resolve(axiosInstance(error.config));
          });
        }
      }
      return Promise.reject(error);
    }
  );

  return axiosInstance;
};

export default apiClient;
